import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from '../services/apiSlice';

export const store = configureStore({
  reducer: {
    // Menambahkan reducer dari RTK Query
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  // Menambahkan custom middleware dari RTK Query
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});
